import { render, staticRenderFns } from "./sendPagePOS.vue?vue&type=template&id=1290528b&"
import script from "./sendPagePOS.vue?vue&type=script&lang=js&"
export * from "./sendPagePOS.vue?vue&type=script&lang=js&"
import style0 from "./sendPagePOS.vue?vue&type=style&index=0&id=1290528b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports